import React from "react";
import * as CSS from "csstype";

import { Flex, HStack, StatLabel, Text } from "@chakra-ui/react";

import { DEFAULT_EMPTY_VALUE, formatDate } from "util/statHelpers";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import ContractStat from "./ContractStat";

const statSpacing = mobileStyleBreakpoint(7, 8);

const FormattedDateText = ({ date }: { date: Date | undefined | "-" }) => (
  <Text textStyle="body" fontWeight="black" color="grey.700">
    {formatDate(date ?? DEFAULT_EMPTY_VALUE)}
  </Text>
);

const ShipStartEndWidget = ({
  loaded,
  startDate,
  endDate,
  desktopRightAligned = false,
}: {
  loaded: boolean;
  startDate?: Date | "-";
  endDate?: Date | "-";
  desktopRightAligned?: boolean;
}): React.ReactElement => {
  const justify = mobileStyleBreakpoint<CSS.Property.JustifyContent>(
    "flex-start",
    desktopRightAligned ? "flex-end" : "flex-start"
  );

  return (
    <HStack spacing={statSpacing} flex={1} justify={justify}>
      <ContractStat
        label={
          <Flex align="center" mb={1} justify={justify}>
            <StatLabel whiteSpace="nowrap" mb={0}>
              Start Ship
            </StatLabel>
          </Flex>
        }
        isLoaded={loaded}
        maxWidth="150px"
        desktopRightAligned={desktopRightAligned}
      >
        <FormattedDateText date={startDate} />
      </ContractStat>
      <ContractStat
        label={
          <Flex align="center" mb={1} justify={justify}>
            <StatLabel whiteSpace="nowrap" mb={0}>
              End Ship
            </StatLabel>
          </Flex>
        }
        isLoaded={loaded}
        maxWidth="150px"
        desktopRightAligned={desktopRightAligned}
        textStyle="body"
        fontWeight="black"
        color="grey.700"
      >
        <FormattedDateText date={endDate} />
      </ContractStat>
    </HStack>
  );
};

export default ShipStartEndWidget;
